import { POSTS_SERVICE } from "@/services/posts.service.js";

const state = {getPostsOutput: {}, postPostOutput: false, putPostOutput: false, getPostByIdOutput: {}, putPostChangeStatusByIdOutput: false};

const actions = {
    //Service to get posts.
    getPosts({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getPostsRequest');

        POSTS_SERVICE.getPosts(queryParams)
            .then(
                output => {
                    commit('getPostsSuccess', output);
                },
                error => {
                    commit('getPostsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service for admin create posts
    postPost({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postPostRequest');

        POSTS_SERVICE.postPost(input)
            .then(
                output => {
                    commit('postPostSuccess', output);
                },
                error => {
                    commit('postPostFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service for admin update posts
    putPost({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putPostRequest');

        POSTS_SERVICE.putPost(input)
            .then(
                output => {
                    commit('putPostSuccess', output);
                },
                error => {
                    commit('putPostFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get details of a specific post
    getPostById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getPostByIdRequest');

        POSTS_SERVICE.getPostById(id)
            .then(
                output => {
                    commit('getPostByIdSuccess', output);
                },
                error => {
                    commit('getPostByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service for admin change visibility
    putPostChangeStatusById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('putPostChangeStatusByIdRequest');

        POSTS_SERVICE.putPostChangeStatusById(id)
            .then(
                output => {
                    commit('putPostChangeStatusByIdSuccess', output);
                },
                error => {
                    commit('putPostChangeStatusByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //getPosts
    getPostsRequest(state) {
    },
    getPostsSuccess(state, output) {
        state.getPostsOutput = output;
    },
    getPostsFailure(state) {
        state.getPostsOutput = false;
    },

    //postPost
    postPostRequest(state) {
        state.postPostOutput = null;
    },
    postPostSuccess(state, output) {
        state.postPostOutput = true;
    },
    postPostFailure(state) {
        state.postPostOutput = false;
    },

    //putPost
    putPostRequest(state) {
        state.putPostOutput = null;
    },
    putPostSuccess(state, output) {
        state.putPostOutput = true;
    },
    putPostFailure(state) {
        state.putPostOutput = false;
    },

    //getPostById
    getPostByIdRequest(state) {
    },
    getPostByIdSuccess(state, output) {
        state.getPostByIdOutput = output;
    },
    getPostByIdFailure(state) {
        state.getPostByIdOutput = false;
    },

    //putPostChangeStatusById
    putPostChangeStatusByIdRequest(state) {
        state.putPostChangeStatusByIdOutput = null;
    },
    putPostChangeStatusByIdSuccess(state, output) {
        state.putPostChangeStatusByIdOutput = true;
    },
    putPostChangeStatusByIdFailure(state) {
        state.putPostChangeStatusByIdOutput = false;
    },
};

export const posts = {
    namespaced: true,
    state,
    actions,
    mutations
};